const _ = require("lodash");
const AT = require("../ActionTypes");

// Pass a vault to this function to make it so that if the denylisted types
// below are dispatched twice in a short time period, only the first dispatch
// is allowed.

const DUPLICATE_THRESHOLD = 200; // milliseconds

// These are the only action types affected by this fix.
const denylistedTypes = {
	[AT.REPORT_BUG]: true,

	[AT.SUBMIT_TRIAL]: true,
	[AT.SUBMIT_TEST]: true,
	[AT.SAVE_TEST_ANSWER]: true,
	[AT.REPLAY_BLOCK]: true,
	[AT.REPLAY_PROBLEM]: true,
	[AT.REQUEST_SPECIFIC_SET]: true,

	[AT.START_OFFICE_LOGIN]: true,
	[AT.ADD_BOOKS_TO_CART]: true,
	[AT.ADD_ITEM_TO_CART]: true,
	[AT.REMOVE_ITEM_FROM_CART]: true,
	[AT.UPDATE_CART_ITEM_QUANTITY]: true,
	[AT.UPDATE_CART_FORMDATA]: false,
	[AT.UPDATE_CART_SHOULD_COPY_SHIPPING]: true,

	[AT.UPDATE_TEMP_PASSWORD]: true,
	[AT.LOGOUT_USER_REQUEST]: true,
	[AT.SEND_BUG_REPORT_REQUEST]: true,
	[AT.BLOCK_HISTORY_REQUEST]: true,
	[AT.PLAY_BLOCK_REQUEST]: true,
	[AT.PLAY_LAB_BLOCK_REQUEST]: true,
	[AT.QUIT_TEST_BLOCK_REQUEST]: true,
	[AT.SUBMIT_CONTACT_FORM_REQUEST]: true,
	[AT.EMAIL_SIGN_UP_REQUEST]: true,
	[AT.DEMO_EMAIL_SIGN_UP_REQUEST]: true,
	[AT.START_PAYPAL_REQUEST]: true,
	[AT.PREPARE_ORDER_REQUEST]: true,
	[AT.PLACE_ORDER_REQUEST]: true,
	[AT.RESEND_CHECKOUT_EMAILS_REQUEST]: true,
	[AT.DEV_ENDPOINT_REQUEST]: true,
};

const addDuplicateDispatchFix = function(vault, vaultLogger) {
	// Date.now might decrease, so make that a fallback.
	const getNow = global.performance
		? () => global.performance.now()
		: () => Date.now();
	const seenTypes = {};

	vault.addDispatchMiddleware(action => {
		const now = getNow();
		if (
			seenTypes[action.type] &&
			now - seenTypes[action.type] < DUPLICATE_THRESHOLD
		) {
			vaultLogger.logSuppressedAction(action, "Double dispatched action type");
			return null; // Prevents action from being handled
		} else if (denylistedTypes[action.type]) {
			seenTypes[action.type] = now;
		}
		return action;
	});

	setInterval(() => {
		const now = getNow();
		const deleteKeys = [];
		_.each(seenTypes, (time, key) => {
			if (now - time >= DUPLICATE_THRESHOLD) {
				deleteKeys.push(key);
			}
		});
		deleteKeys.forEach(key => {
			delete seenTypes[key];
		});
	}, 500 * DUPLICATE_THRESHOLD);
};

module.exports = {
	addDuplicateDispatchFix,
};
